import styled from "styled-components";

export const StyledChatContent = styled.div`
  flex: 1;
  padding: var(--spacing-lg) var(--spacing-md) 0;
  overflow-y: auto;
`;
